import { loadScript } from '../loadScript'
import config from '../config'

/**
 * Включение библиотеки jQuery
 */
const jquery = {
  state: {
    lib: config.STATIC + 'libs/jquery/3.4.1/jquery.min.js',
    isActive: false
  },
  activate: function () {
    // Выйти, если повторный запуск интеграции jQuery
    if (window.jQuery) {
      this.state.isActive = true
      return
    }
    loadScript(this.state.lib)
    this.state.isActive = true
  }
}
export default jquery
